import React, { useEffect } from 'react';
import Label from './fromLabel';
import Error from './fromError';


interface InputProps {
    type: 'text' | 'password' | 'email' | 'number' 
    placeholder?: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    disabled?: boolean;
    label?: string;
    required?: boolean;
    info?:string;
    error?:string;
    className?: string;
    size?: 'sm' | 'md' | 'lg';
}

const Input: React.FC<InputProps> = ({ type, placeholder, value, size='md', onChange,className='' , disabled = false,label,required, info, error}) => {

    return (
        <div className={`my-6 ${className}`}>
            {label && <Label text={label} required={required} info={info} />}
            <input
                type={type}
                placeholder={placeholder}
                value={value || ''}
                onChange={onChange}
                disabled={disabled}
                className={` ${error ? 'border-red-500 border-2' : 'border-[#CECECE] border'} rounded-md focus:outline-none  focus:primary ${size == 'sm'?'text-[0.667rem] mt-0 pl-2 py-1  font-normal h-[1.875rem]':'text-[0.938rem] mt-2 pl-4 py-2  font-normal h-[2.875rem]'} text-[#222222] placeholder:text-[#a1a1a1] w-full `}
            />
            {error && <Error message={error} />}
        </div>
    );
};

export default Input;